export function addVideoToPage(container, classname) {
  const videoContainers = (container ?? document).getElementsByClassName(
    classname ?? 'load-video'
  );

  for (let i = 0; i < videoContainers.length; i++) {
    const containerEl = videoContainers[i];

    if (!containerEl.hasAttribute('data-videosrc')) continue;
    let videosrc = containerEl.getAttribute('data-videosrc');
    if (!videosrc) continue;

    if (
      document.body.classList.contains('mobile') &&
      containerEl.classList.contains('no-mobile')
    )
      continue;

    // --- ustawienia wideo ---
    let videoAutoplay = true;
    let videoloop = true;
    let videocontrols = false;
    let videomuted = true;

    const videoAutoplaySeting = containerEl.getAttribute('data-videoautoplay');
    if (videoAutoplaySeting) videoAutoplay = videoAutoplaySeting !== 'false';

    const videoloopSeting = containerEl.getAttribute('data-videoloop');
    if (videoloopSeting) videoloop = videoloopSeting !== 'false';

    const videoControlsSeting = containerEl.getAttribute('data-videocontrols');
    if (videoControlsSeting) videocontrols = videoControlsSeting !== 'false';

    const videoMutedSeting = containerEl.getAttribute('data-videomuted');
    if (videoMutedSeting) videomuted = videoMutedSeting !== 'false';

    // --- tworzymy element video ---
    let video = document.createElement('video');
    video.classList.add('video-bg__video');
    if (containerEl.getAttribute('data-class')) {
      video.classList.add(containerEl.getAttribute('data-class'));
    }

    video.loop = videoloop;
    video.controls = videocontrols;
    video.autoplay = videoAutoplay;

    // Safari wymaga: muted + playsinline
    video.muted = true; // autoplay wymaga muted
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const poster = containerEl.getAttribute('data-videoposter');
    if (poster) video.setAttribute('poster', poster);

    // zachowujemy Twoją logikę mutowania
    if (!videomuted) video.muted = false;

    video.dataset.pauseout = containerEl.getAttribute('data-pauseout') || false;

    // sprawdzamy czy Safari może odtworzyć mp4
    if (video.canPlayType('video/mp4') !== '') video.src = videosrc;
    else continue;

    containerEl.appendChild(video);

    // --- funkcja play z obsługą blokady Safari ---
    const tryPlay = () => {
      video.play().catch(err => {
        // jeśli blokada, poczekaj na user gesture
        // console.log('Autoplay blocked:', err);
      });
    };

    // --- IntersectionObserver dla lazy-play ---
    if (containerEl.classList.contains('play-when-visible')) {
      video.pause();
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              tryPlay();
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.2, rootMargin: '-10px' }
      );
      observer.observe(video);
    } else {
      // próbujemy od razu
      tryPlay();
    }

    // --- fallback: jeśli Safari zablokuje autoplay, odpali po pierwszej interakcji ---
    const userGestureHandler = () => {
      tryPlay();
      document.removeEventListener('click', userGestureHandler);
      document.removeEventListener('touchstart', userGestureHandler);
      document.removeEventListener('scroll', userGestureHandler);
    };
    document.addEventListener('click', userGestureHandler);
    document.addEventListener('touchstart', userGestureHandler);
    document.addEventListener('scroll', userGestureHandler, { passive: true });
  }
}

export function addVideoToPage_OLD2(container, classname) {
  const videoContainers = (container ?? document).getElementsByClassName(
    classname ?? 'load-video'
  );

  for (let i = 0; i < videoContainers.length; i++) {
    if (!videoContainers[i].hasAttribute('data-videosrc')) {
      continue;
    }
    let videosrc = videoContainers[i].getAttribute('data-videosrc');
    if (!videosrc) {
      continue;
    }

    if (
      document.body.classList.contains('mobile') &&
      videoContainers[i].classList.contains('no-mobile')
    )
      continue;

    let videoAutoplay = true;
    let videoloop = true;
    let videocontrols = false;
    let videomuted = true;

    let videoAutoplaySeting =
      videoContainers[i].getAttribute('data-videoautoplay');
    if (videoAutoplaySeting) {
      videoAutoplay = videoAutoplaySeting == 'false' ? false : true;
    }

    let videoloopSeting = videoContainers[i].getAttribute('data-videoloop');

    if (videoloopSeting) {
      videoloop = videoloopSeting == 'false' ? false : true;
    }

    let videoControlsSeting =
      videoContainers[i].getAttribute('data-videocontrols');
    if (videoControlsSeting) {
      videocontrols = videoControlsSeting == 'false' ? false : true;
    }

    let videoMutedSeting = videoContainers[i].getAttribute('data-videomuted');
    if (videoMutedSeting) {
      videomuted = videoMutedSeting == 'false' ? false : true;
    }

    let video = document.createElement('video');
    video.classList.add('video-bg__video');

    video.loop = videoloop;
    video.autoplay = videoAutoplay;
    video.controls = videocontrols;

    video.muted = true; // zawsze true dla autoplay
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // opcjonalnie zachowujemy Twoją logikę (ale Safari i tak wymusi muted)
    if (!videomuted) {
      video.muted = false;
    }

    video.dataset.pauseout =
      videoContainers[i].getAttribute('data-pauseout') || false;

    let videoClass = videoContainers[i].getAttribute('data-class');
    if (videoClass) {
      video.classList.add(videoClass);
    }

    if (video.canPlayType('video/mp4') !== '') {
      video.src = videosrc;
    } else {
      continue;
    }

    /*
    if (videoContainers[i].classList.contains("play-when-visible")) {
      video.pause();
      addObserverToVideo({ elements: [video] });
    }
    */

    videoContainers[i].appendChild(video);

    if (videoAutoplay) {
      video.play().catch(err => {
        console.log('Autoplay blocked:', err);
      });
    }
  }
}

export function addVideoToPage_OLD(container, classname) {
  const videoContainers = (container ?? document).getElementsByClassName(
    classname ?? 'load-video'
  );

  for (let i = 0; i < videoContainers.length; i++) {
    if (!videoContainers[i].hasAttribute('data-videosrc')) {
      continue;
    }
    let videosrc = videoContainers[i].getAttribute('data-videosrc');
    if (!videosrc) {
      continue;
    }

    if (
      document.body.classList.contains('mobile') &&
      videoContainers[i].classList.contains('no-mobile')
    )
      continue;

    let videoAutoplay = true;
    let videoloop = true;
    let videocontrols = false;
    let videomuted = true;

    let videoAutoplaySeting =
      videoContainers[i].getAttribute('data-videoautoplay');
    if (videoAutoplaySeting) {
      videoAutoplay = videoAutoplaySeting == 'false' ? false : true;
    }

    let videoloopSeting = videoContainers[i].getAttribute('data-videoloop');
    if (videoAutoplaySeting) {
      videoloop = videoloopSeting == 'false' ? false : true;
    }

    let videoControlsSeting =
      videoContainers[i].getAttribute('data-videocontrols');
    if (videoControlsSeting) {
      videocontrols = videoControlsSeting == 'false' ? false : true;
    }

    let videoMutedSeting = videoContainers[i].getAttribute('data-videomuted');
    if (videoMutedSeting) {
      videomuted = videoMutedSeting == 'false' ? false : true;
    }

    let video = document.createElement('video');
    video.classList.add('video-bg__video');
    video.loop = videoloop;
    video.muted = videomuted;
    video.autoplay = videoAutoplay;
    video.controls = videocontrols;

    video.dataset.pauseout =
      videoContainers[i].getAttribute('data-pauseout') || false;

    let videoClass = videoContainers[i].getAttribute('data-class');
    if (videoClass) {
      video.classList.add(videoClass);
    }

    if (video.canPlayType('video/mp4').length > 0) {
      video.src = videosrc;
    } else {
      continue;
    }
    /*
    if (videoContainers[i].classList.contains("play-when-visible")) {
      video.pause();
      addObserverToVideo({ elements: [video] });
    }
      */

    videoContainers[i].appendChild(video);
  }
}

function addObserverToVideo(config) {
  const { root, threshold } = config;
  let { elements } = config;

  const options = {
    root: root ? root : null,
    threshold: threshold ? threshold : 0.2,
    rootMargin: '-10px',
  };

  if (!elements) {
    elements = [];
  }

  elements.forEach(element => {
    element.pause();
  });

  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('isIntersecting');
        console.log(entry.target);
        entry.target.play();
      } else {
        console.log('---- NO isIntersecting');
        console.log(entry.target);
        entry.target.pause();
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  elements.forEach(element => {
    observer.observe(element);
  });
}
